import { registerAuthInterceptor } from './authInterceptor';
import { client } from './generated/client.gen';

/**
 * Centralised SDK configuration. The generated `client.gen.ts` defaults to
 * `http://localhost/` for typings; at runtime we override the baseUrl so the
 * SPA hits the dev API (proxy / VITE_API_BASE_URL) or the production origin.
 */
const baseUrl = import.meta.env.VITE_API_BASE_URL ?? '';

client.setConfig({ baseUrl });
registerAuthInterceptor(client);

export { client };
